import { InjectionToken } from '@angular/core';

/** Help-menu item definition before labels are resolved via Transloco. */
export type TopbarHelpMenuItemConfig = {
  /** Transloco key relative to the `global` scope (e.g. `help.documentation`). */
  labelKey: string;
  /** PrimeIcons class list (e.g. `pi pi-file`). */
  icon?: string;
  /** Internal app route opened via the Angular router. */
  routerLink?: string;
  /** Link target for external URLs. */
  target?: string;
  /** External URL (mailto, WhatsApp, etc.). */
  url?: string;
};

/**
 * Factory function that builds the topbar help-menu items for a given brand.
 *
 * Returns static navigation metadata plus {@link TopbarHelpMenuItemConfig.labelKey}
 * values. {@link Topbar} resolves labels through the `global` Transloco scope so
 * scoped translations load and re-render on language change.
 *
 * Kept in `shared/feature` (not `shared/model`) so that `shared/model` does
 * not gain a PrimeNG dependency — `shared/feature` already depends on PrimeNG.
 *
 * @example
 * // In a brand provider helper:
 * {
 *   provide: TOPBAR_HELP_ITEMS_FACTORY,
 *   useValue: (): TopbarHelpMenuItemConfig[] => [
 *     { labelKey: 'help.support', icon: 'pi pi-envelope', url: 'mailto:support@brand.com' },
 *   ],
 * }
 */
export const TOPBAR_HELP_ITEMS_FACTORY = new InjectionToken<
  () => TopbarHelpMenuItemConfig[]
>('TOPBAR_HELP_ITEMS_FACTORY');
